import { defineMessages } from 'react-intl';

export default defineMessages({
    anErrorOccurred: {
        id: 'gw-portals-policytransaction-pc-ba.wizard.error',
        defaultMessage: 'Something went wrong during this process.'
    },
    anErrorOccurredTitle: {
        id: 'gw-portals-policytransaction-pc-ba.wizard.error.title',
        defaultMessage: 'Error'
    },
    saveQuoteError: {
        id: 'gw-portals-policytransaction-pc-ba.Unable to quote',
        defaultMessage: 'Unable to quote'
    },
    saveQuoteErrorMessage: {
        id: 'gw-portals-policytransaction-pc-ba.An error occurred while attempting to quote.',
        defaultMessage: 'An error occurred while attempting to quote.'
    },
    backDatedEndorsement:{
        id: 'endorsement.ba.directives.templates.ba-whats-next.Back Dated Endorsement',
        defaultMessage: 'Back Dated Endorsement'
    },
    noPriorClaimsOccurred: {
        id: 'endorsement.ba.directives.templates.ba-whats-next.Confirm No Prior Claims Occurred',
        defaultMessage: 'Do you confirm that no claims have occurred in this prior period?'
    }
});
